

























import { Component } from 'vue-property-decorator';
import { BaseCustomComponent } from './custom/base-custom-component';
import { ComponentModel } from '@/models';

@Component
export default class TreeView extends BaseCustomComponent {
  expanded: boolean = true;

  toggle() {
    this.expanded = !this.expanded;
  }

  get hasChildren() {
    return this.model.children && this.model.children.length;
  }
}
